import {axiosRequest} from "../api";
import {API_PATH} from "../../constants";

export const ConditionService = {
    getConditionsList(params){ return axiosRequest('GET', API_PATH.CONDITION.LIST(params)) },
    getCondition(data){ return axiosRequest('POST', API_PATH.CONDITION.INFO, data) },
    addCondition(data){ return axiosRequest('POST', API_PATH.CONDITION.ADD, data) },
    deleteCondition(data){ return axiosRequest('POST', API_PATH.CONDITION.DELETE, data) },
}